import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import AlertGenericModal from 'react/containers/modals/AlertGenericModal';
import { actionCreators } from 'react/api/actions/integrations';
import { getResourceTo } from 'react/utils/utils';

function SwitchCheckbox({
  checked,
  onChange,
  onDisableCallback,
  integrationData
}) {
  const {
    integration
  } = useMemo(
    () => JSON.parse(integrationData),
    [integrationData]
  );

  const dispatch = useDispatch();
  const { isDisabling, error } = useSelector((state) => state.integrations.get('disableState'));

  const errorMessage = useMemo(
    () => (!isDisabling && error ? error.message : null),
    [error, isDisabling]
  );

  const [isOpenDisabledModal, setOpenDisabledModal] = useState(false);

  const handleChange = () => {
    if (checked) {
      setOpenDisabledModal(true);
    } else {
      onChange && onChange({
        checked: !checked
      });
    }
  };

  const closeModalAndClearState = () => {
    setOpenDisabledModal(false);
    dispatch(actionCreators.clearIntegrationDisableState());
  };

  const confirmButton = () => {
    onDisableCallback && onDisableCallback();
  };

  const cancelButton = () => {
    closeModalAndClearState();
  };

  useEffect(() => {
    if (!isDisabling) {
      closeModalAndClearState();
    }
  }, [isDisabling]);

  return (
    <>
      <input
        id={integration.name}
        data-testid={`switch-input-${integration.name}-${checked ? 'enabled' : 'disabled'}`}
        className="switch"
        type="checkbox"
        checked={checked}
        onChange={handleChange}
      />
      <label htmlFor={integration.name}>
        <div
          data-testid={`switch-label-${integration.name}`}
          className={`labelSwitch ${checked ? 'enabled' : 'disabled'} `}
        >
          {checked ? getResourceTo('Integration.Switch.EnabledLabel')
            : getResourceTo('Integration.Switch.DisabledLabel')}
        </div>
      </label>

      <AlertGenericModal
        open={isOpenDisabledModal}
        i18n={Monet.I18n}
        isLoading={isDisabling}
        title="IntegrationModal.DisableIntegrationModal.Title"
        message={getResourceTo('IntegrationModal.DisableIntegrationModal.Message', integration.name)}
        confirmClickButton={confirmButton}
        cancelClickButton={cancelButton}
        errorMessage={errorMessage}
        customConfirmButtonResource="IntegrationModal.DisableIntegrationModal.ConfirmButtonText"
        formatMessageBodyAsHTML
      />
    </>
  );
}

SwitchCheckbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  onDisableCallback: PropTypes.func,
  onChange: PropTypes.func,
  integrationData: PropTypes.string
};

SwitchCheckbox.defaultProps = {
  id: null
};

export default SwitchCheckbox;
